module.exports = __webpack_public_path__ + "img/01.d6b44cac.png";